import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {CREATE_CDC_CARD_ERROR, CREATE_CDC_CARD_START, CREATE_CDC_CARD_SUCCESS} from "../../types";

export function* create({payload}) {
  try {
    const url = '/cdc_card_caregories/';
    const method = 'POST';
    const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'multipart/form-data'};
    const data = (object) => Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());
    const results = yield call(apiCall, url, method, data(payload.formData), headers);
    yield put({type: CREATE_CDC_CARD_SUCCESS, results: results.data});
    yield put(payload.navigate('/app/content-management/manage-card-category'));
  } catch (error) {
    yield put({type: CREATE_CDC_CARD_ERROR, error});
  }
}

export default function* create_banner() {
  yield takeLatest(CREATE_CDC_CARD_START, create);
}
